import cls from "classnames";
import { useState } from "react";

import { ButtonPrimary } from "@qoohoo/common/components/library/Button";

import useAppState from "store/appState";

import { closeCheckout } from "helpers/postmessage/emitters";

import CrossIcon from "components/icons/CrossIcon";
import Footer from "components/Footer";
import SlotPicker from "./SlotPicker";
import MeetingDetails from "./MeetingDetails";

export default function BookMeetingContent({ isStandalone }) {
  const [isBookSlotScreen, setIsBookSlotScreen] = useState(false);
  const canCustomerCloseCheckout = useAppState(
    (state) => state.canCustomerCloseCheckout
  );

  const handleFooterButtonClick = () => {
    setIsBookSlotScreen(true);
  };

  const handleBackButton = () => {
    setIsBookSlotScreen(false);
  }

  function handleCheckoutClose() {
    closeCheckout();
  }

  return (
    <div className="w-full h-full">
      {canCustomerCloseCheckout && (
        <div
          className="absolute top-[1.125rem] right-4 cursor-pointer z-[50]"
          onClick={handleCheckoutClose}
        >
          <CrossIcon />
        </div>
      )}
      <div
        className={cls(
          "h-full flex md:items-start md:gap-8 lg:gap-20 md:p-5 lg:p-10",
          !isStandalone && "items-start md:pb-10 lg:pb-12 overflow-auto scrollbar-hide",
        )}
      >
        <div
          className={cls(
            "flex-1 shrink-0 min-w-0 pb-20 md:pb-0 flex flex-col",
            isBookSlotScreen ? "hidden md:block" : "block"
          )}
        >
          <MeetingDetails />
          {isStandalone && <Footer className="px-5 sm:px-8 md:hidden py-3 border-t mt-auto border-t-[#e8e8e8]"/>}
          <SelectSlotButton onButtonClick={handleFooterButtonClick} />
        </div>
        <div
          className={cls(
            "flex-1 shrink-0 min-w-0 pb-20 md:pb-0 flex flex-col md:h-full",
            isBookSlotScreen ? "block" : "hidden md:block"
          )}
        >
          <div className="md:top-5 lg:top-10 md:sticky">
            <SlotPicker handleBackButton={handleBackButton}/>
          </div>
          {isStandalone && <Footer className="px-5 sm:px-8 md:hidden py-3 mt-auto border-t border-t-[#e8e8e8]"/>}
        </div>
      </div>
    </div>
  );
}

function SelectSlotButton({ onButtonClick }) {
  return (
    <div
      className={cls(
        "fixed flex md:hidden left-0 right-0 bottom-0 px-5 pt-4 pb-6 sm:pb-4 bg-white shadow-[0px_-4px_15px_0px_#0000000D]"
      )}
    >
      <ButtonPrimary
        onClick={onButtonClick}
        className="w-full max-w-md bg-primary mx-auto"
      >
        Select your slot
      </ButtonPrimary>
    </div>
  );
}